import { Box, Row, Text } from '~/commonComponents';
import { JobPostingStatus, JobPostingStatusMapper } from '~/domain/PermanentJobs';

interface IJobStatusInfoProps {
  jobStatus: JobPostingStatus;
}

export const JobStatusInfo = ({ jobStatus }: IJobStatusInfoProps) => (
  <Row alignItems="center" gap={6}>
    <Text bold fontSize={18} textWrap="nowrap">
      Job Status<Text>:</Text>
    </Text>
    <Box
      backgroundColor={JobPostingStatusMapper.getColor(jobStatus)}
      borderRadius="100%"
      height={10}
      width={10}
    />
    <Text>{JobPostingStatusMapper.toHumanReadable(jobStatus)}</Text>
  </Row>
);
